import { render, staticRenderFns } from "./ImageCompareWindow.vue?vue&type=template&id=65c7d5b8&scoped=true&"
import script from "./ImageCompareWindow.vue?vue&type=script&lang=js&"
export * from "./ImageCompareWindow.vue?vue&type=script&lang=js&"
import style0 from "./ImageCompareWindow.vue?vue&type=style&index=0&id=65c7d5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7d5b8",
  null
  
)

export default component.exports